import { Inject, Pipe, PipeTransform } from "@angular/core";
import { DeviceFieldValues, CpeFieldValues } from "@nms-ng2/app/modules/template/template-instance/template-instance-models";
import { RuleType } from "../components/elements/matching-rules/matching-rules.models";
import { ANGULARJS_TRANSLATE } from "../services/upgraded-provider/upgraded-providers";

/**
 * Pipe utilizado para criação do texto na restrição de firmware entre duas faixas de valores.
 */
@Pipe({name: "firmwareRangeRule"})
export class FirmwareRangeRulePipe implements PipeTransform {

    constructor(@Inject(ANGULARJS_TRANSLATE) private readonly $translate) {}

    transform(equipmentRuleOptions = []) : string {
        let firmwareRangeRule = "";
        const firmareRuleOption = equipmentRuleOptions.find(equipmentRuleOption => {
            return equipmentRuleOption.equipmentField.value === DeviceFieldValues.FIRMWARE ||
                equipmentRuleOption.equipmentField.value === CpeFieldValues.SW_VERSION;
        });

        if (firmareRuleOption) {
            const ruleType = RuleType[firmareRuleOption.ruleType];
            const [firmwareA, firmwareB] = firmareRuleOption.values;

            if (ruleType) {
                const translationKey = `restrictions.rule.type.${ruleType}`
                firmwareRangeRule = `${this.$translate.instant(translationKey)} ${firmwareA}`;

                if (firmwareB) {
                    firmwareRangeRule += ` - ${firmwareB}`;
                }
            }
        }

        return firmwareRangeRule;
    }
}
